import React from 'react';
import { init } from './LiveRampManager';

const LiveRamp = ({ liverampId, children }) => {
  init(liverampId);
  return <>{children}</>;
};

export default LiveRamp;
